/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/km-product-i18n.js
 * Traductions FR/EN pour toute la page produit
 * Doit être chargé APRÈS window.KM_LANG
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  var lang = (window.KM_LANG || 'fr').toLowerCase();

  var T = lang === 'en' ? {
    // ── SECTION 3 : Formulaire produit ──
    trust_reviews: '127 verified reviews',
    trust_events: '🔥 +500 events',
    product_desc: 'Collect all your guests\' photos and videos with a simple scan. No app required. Instant delivery by email.',
    price_label: 'Price',
    price_badge_1: 'One-time payment',
    price_badge_2: '📅 6-month access',
    info_6m_strong: '6-month access to your gallery',
    info_6m_text: ' from the creation date. Download your photos & videos at any time during this period.',
    poster_title: 'Choose your QR code poster',
    poster_none: 'No design selected',
    poster_zoom: '🔍 Click a thumbnail to zoom and select',
    poster_zoom_overlay: '🔍 View & select',
    poster_names: [
      'Spring Mist',
      'Captured Moments',
      'Eternal Elegance',
      'Bohemian Softness',
      'Romantic Rose',
      'Golden Promise',
      'Vintage Eternity',
      'Floral Promise',
      'Prestige Evening',
      'Memory Cocktail',
      'Party Sketch',
      'Golden Softness',
      'Ribbons of Joy',
      'Minimal Moment',
      'Party Moment'
    ],
    poster_descs: [
      'Warm and elegant style, perfect for weddings in natural light.',
      'A playful and symbolic card that invites guests to capture every magical moment.',
      'Natural and rustic ambiance, ideal for outdoor weddings.',
      "Like a summer memory captured in soft and natural light.",
      'A tender moment where flowers and love bloom together.',
      'A precious love celebrated in light and elegance.',
      'Timeless elegance evoking the beauty of memories that last a lifetime.',
      'A romantic and delicate atmosphere celebrating the union of two hearts.',
      'An explosion of joy and colors to immortalize a party full of energy.',
      "A sparkling card capturing the light and festive spirit of a birthday among friends.",
      'An artistic and modern aesthetic for a creative and spontaneous birthday.',
      'Deep navy blue and gold. Nautical elegance and prestige assured.',
      'A festive and refined invitation to share the memories of a joyful birthday.',
      'A simple and modern design leaving all the room for authentic memories.',
      'A moment filled with joy where every smile becomes a precious memory.'
    ],
    poster_imgs: [
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/1.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/2.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/3.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/4.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/5_3353fcfb-2262-43ae-a3b2-550db471953b.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/6_8d0c3fbe-54c8-4095-9118-64612c3ac3fc.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/7_e2b501fd-f055-4128-a777-8f24f8fb8bfb.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/8_b0fbee12-86f0-46b3-8933-de7477b896a2.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/9_871ebbb1-2f4d-4bbd-8885-2afdaf2382a1.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/10_1ceddde2-40da-4209-9bb2-5b8fd0502f14.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/11.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/12_0f79f0ae-9200-42d3-a397-b94fb82baaac.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/13_20b5d100-46bd-4fec-88a0-37cae2bdccde.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/14.jpg?v=1774537611',
      'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/15.jpg?v=1774537611'
    ],
    error_poster: '⚠️ Please choose a QR code poster before continuing.',
    error_name: '⚠️ Please enter the names to display on the QR code poster before continuing.',
    form_title: 'Customize your poster',
    form_name_label: 'Names to display',
    form_name_placeholder: 'E.g.: Tom & Eve, Marie and Pierre...',
    form_name_counter_suffix: ' / 24 characters',
    form_preview: 'Preview:',
    form_event_label: 'Event name',
    form_event_opt: '(optional)',
    form_event_placeholder: 'Leave blank to keep the default',
    form_event_counter_suffix: ' / 20 characters',
    form_event_helper: 'Change if you want to replace "Wedding", "Birthday", etc.',
    atc_btn: '→ Create my gallery now',
    atc_loading: 'Loading…',
    feat_1: 'No app required',
    feat_2: 'Instant access',
    feat_3: '15 QR code posters',
    feat_4: 'Private gallery',
    feat_5: '1-click download',
    feat_6: '7/7 support',
    pay_label: '🔒 Secure payment',
    reassurance_1: 'Secure payment',
    reassurance_2: 'Refunded within 30 days',
    reassurance_3: 'Instant delivery',
    garantie_title: 'Satisfaction guaranteed within 30 days',
    garantie_text: "If KeepMemoriz doesn't meet your expectations, we'll refund you in full. No conditions. No questions.",
    faq_label: 'Frequently asked questions',
    faq_q1: 'When do I receive my access?',
    faq_a1: 'Immediately after payment, you receive an email with your access. Everything is ready within minutes.',
    faq_q2: 'Do my guests need to download an app?',
    faq_a2: 'No. A simple scan with the smartphone camera is enough. Compatible with iPhone and Android, no installation required.',
    faq_q3: 'What happens after 6 months?',
    faq_a3: 'Your gallery is accessible for 6 months. Download all your photos before it expires. An email reminder will be sent.',
    faq_q4: 'Can I change the poster after purchase?',
    faq_a4: 'Yes, you can change the poster. Just send us the poster you want by email.',
    faq_q5: "What if I'm not satisfied?",
    faq_a5: 'Full refund within 30 days, no conditions, no justification needed.',
    modal_select: '✓ Select this design',
    modal_selected: '✓ Design selected!',

    // ── SECTION 5 : Pourquoi KeepMemoriz ──
    why_tag: 'Why KeepMemoriz?',
    why_title: 'The problem nobody sees coming<br><em>until the day after the wedding.</em>',
    why_sub: 'Your guests filmed. They took photos. But getting it all back takes weeks, if it ever happens.',
    why_bad_title: 'Without KeepMemoriz',
    why_good_title: 'With KeepMemoriz',
    why_bad: [
      "Photos stay on your guests' phones, often forever",
      "Your photographer couldn't capture the back table or the late-night dances",
      "You message each guest, half of them never reply",
      "What they finally send is compressed by WhatsApp, blurry or cropped",
      "A few months later, the photos are gone when the guest changed phones",
      "There's no single place where everything is gathered, every memory is somewhere else"
    ],
    why_good: [
      'All photos arrive in a gallery as soon as your guests share them',
      'Every table, every hallway, every dance covered by someone',
      'Your guests scan the QR code with their camera, no app to download',
      'Files are stored in original quality, no compression or automatic cropping',
      'Your gallery stays accessible for 6 months, download everything in one click whenever you want',
      'One link, one gallery, all perspectives of your event'
    ],
    why_stat1_label: 'photos shared on average per wedding',
    why_stat2_label: 'for a guest to share their first photo',
    why_stat3_label: 'events captured since launch',
    why_stat4_label: 'average rating on 127 verified reviews',
    why_cta: '→ Create my gallery  €49.99',
    why_cta_sub1: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg> Instant access',
    why_cta_sub2: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><path d="M23 4v6h-6"></path><path d="M1 20v-6h6"></path><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path></svg> 30-day money-back',
    why_cta_sub3: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Gallery active for 6 months',
    why_demo_q: 'Want to see how it works before buying?',
    why_demo_btn: 'Try the free demo',
    sticky_name: 'Wedding and Birthday QR Code, Guest Photo & Video Gallery',
    sticky_btn: '→ Create my gallery',

    // ── SECTION 6 : Vidéos étapes ──
    vid_tag: 'See it in action',
    vid_title: 'Create your gallery<br>in <em>under 5 minutes</em>',
    vid_sub: 'Follow these 4 simple steps. Each video shows you exactly what to do.',
    vid_step: 'Step',
    vid_s1_title: 'Log in',
    vid_s1_desc: 'Access your KeepMemoriz space and download your personalized QR code poster',
    vid_s2_title: 'Configure your gallery',
    vid_s2_desc: 'Decide who can add, view or download photos and videos.',
    vid_s3_title: 'Print and display the QR code',
    vid_s3_desc: 'Display the QR code on your tables, seating plan or at the reception entrance.',
    vid_s4_title: 'Download your memories',
    vid_s4_desc: "After the event, download all your photos & videos in one click and relive your event through your loved ones' eyes.",
    vid_demo_text: "You have just seen how it works: create your album now.",
    vid_demo_btn: 'Create my album, €49.99',
    vid_demo_note: 'No credit card · No sign-up · Access in 30 seconds',
    vid_placeholder: 'Video step',

    // ── SECTION 7 : Carrousel avis ──
    reviews_count: '127 verified reviews',
    reviews_title: 'They trust<br><em>us</em>',
    reviews_sub: 'Hundreds of families have captured their moments.',
    reviews_track1: [
      "330 photos and videos from our wedding we would never have had otherwise. Even the moments the photographer missed.",
      "My mother cried.",
      "Even my 60-year-old in-laws got it right on the first try.",
      "We recommend it 100%.",
      "The whole family added their little video messages for the baby. We'll show them when he's older.",
      "5 min to set up. 250 photos the next day.",
      "Love at first sight.",
      "We put the poster in A3 at the entrance. 95% of guests scanned it right away. Over 130 photos in 3 hours."
    ],
    reviews_track2: [
      "My grandmother, 72 years old, scanned the QR code all by herself. 260 photos in one evening.",
      "Customer service is top notch.",
      "The teenagers loved it. 120 videos before midnight.",
      "300 photos shared that same evening for our 200-person seminar. Convenient.",
      "Best wedding purchase.",
      "The next day I had 377 memories in the gallery. Everyone played along.",
      "Perfect for a bachelorette party.",
      "The Spring Mist poster blended right into our decor."
    ]
  } : {
    // ── FR (par défaut) ──
    trust_reviews: '127 avis vérifiés',
    trust_events: '🔥 +500 événements',
    product_desc: 'Collectez toutes les photos et vidéos de vos invités en un simple scan. Sans application. Livraison instantanée par email.',
    price_label: 'Prix',
    price_badge_1: 'Paiement unique',
    price_badge_2: '📅 Accès 6 mois',
    info_6m_strong: 'Accès à votre album pendant 6 mois',
    info_6m_text: ' à compter de la date de création. Téléchargez vos photos & vidéos à tout moment pendant cette période.',
    poster_title: 'Choisissez votre carte de table QR code',
    poster_none: 'Aucun modèle sélectionné',
    poster_zoom: '🔍 Cliquez sur une miniature pour zoomer et sélectionner',
    poster_zoom_overlay: '🔍 Voir & sélectionner',
    poster_names: null,
    poster_descs: null,
    error_poster: '⚠️ Veuillez choisir une carte de table QR code avant de continuer.',
    error_name: '⚠️ Veuillez renseigner vos prénoms sur la carte de table QR code avant de continuer.',
    form_title: 'Personnalisez votre carte de table',
    form_name_label: 'Vos prénoms sur la carte de table',
    form_name_placeholder: 'Ex : Tom & Eve, Marie et Pierre...',
    form_name_counter_suffix: ' / 24 caractères',
    form_preview: 'Aperçu :',
    form_event_label: "Nom de l'événement",
    form_event_opt: '(optionnel)',
    form_event_placeholder: 'Laisser vide pour garder celui du modèle',
    form_event_counter_suffix: ' / 20 caractères',
    form_event_helper: 'Modifiez si vous souhaitez changer "Mariage", "Anniversaire", etc.',
    atc_btn: '→ Créer mon album maintenant',
    atc_loading: 'Chargement…',
    feat_1: 'Sans application',
    feat_2: 'Accès immédiat',
    feat_3: '15 carte de tables QR code',
    feat_4: 'Album privé',
    feat_5: 'Téléchargement 1 clic',
    feat_6: 'Support 7j/7',
    pay_label: '🔒 Paiement sécurisé',
    reassurance_1: 'Paiement sécurisé',
    reassurance_2: 'Remboursé sous 30 jours',
    reassurance_3: 'Livraison instantanée',
    garantie_title: 'Satisfait ou remboursé sous 30 jours',
    garantie_text: 'Si KeepMemoriz ne correspond pas à vos attentes, nous vous remboursons intégralement. Sans condition. Sans question.',
    faq_label: 'Questions fréquentes',
    faq_q1: 'Quand est-ce que je reçois mon accès ?',
    faq_a1: 'Immédiatement après le paiement, vous recevez un email avec votre accès. En quelques minutes, tout est prêt.',
    faq_q2: 'Mes invités doivent-ils télécharger une application ?',
    faq_a2: "Non. Un simple scan avec l'appareil photo du smartphone suffit. Compatible iPhone et Android, sans aucune installation.",
    faq_q3: 'Que se passe-t-il après les 6 mois ?',
    faq_a3: 'Votre album est accessible pendant 6 mois. Téléchargez toutes vos photos avant la fin. Un rappel par email vous sera envoyé.',
    faq_q4: "Puis-je changer de carte de table après l'achat ?",
    faq_a4: "Oui, vous pouvez changer de carte de table, il suffit de nous renvoyer la carte de table que vous souhaitez par e-mail.",
    faq_q5: 'Et si je ne suis pas satisfait ?',
    faq_a5: 'Remboursement intégral sous 30 jours, sans condition ni justification.',
    modal_select: '✓ Sélectionner ce modèle',
    modal_selected: '✓ Modèle sélectionné !',

    why_tag: 'Pourquoi KeepMemoriz ?',
    why_title: 'Le problème que personne ne voit venir<br><em>jusqu\'au lendemain du mariage.</em>',
    why_sub: 'Vos invités ont filmé. Ils ont photographié. Mais récupérer tout ça prend des semaines, quand ça arrive.',
    why_bad_title: 'Sans KeepMemoriz',
    why_good_title: 'Avec KeepMemoriz',
    why_bad: [
      'Les photos dorment sur les téléphones de vos invités, souvent pour toujours',
      "Votre photographe n'a pas pu capturer la tablée du fond ni les danses de fin de soirée",
      'Vous relancez chaque invité par message, la moitié ne répond pas',
      "Ce qu'on vous envoie finalement est compressé par WhatsApp, flou ou recadré",
      "Quelques mois après, les photos ont disparu quand l'invité a changé de téléphone",
      "Il n'existe aucun endroit où tout ça est réuni, chaque souvenir est ailleurs"
    ],
    why_good: [
      'Toutes les photos arrivent dans un album dès que vos invités les partagent',
      'Chaque table, chaque couloir, chaque danse couverts par quelqu\'un',
      "Vos invités scannent le QR code avec leur appareil photo, pas d'application à télécharger",
      'Les fichiers sont stockés en qualité originale, sans compression ni recadrage automatique',
      'Votre album reste accessible 6 mois, téléchargez tout en un clic quand vous voulez',
      'Un seul lien, une seule album, tous les points de vue de votre événement'
    ],
    why_stat1_label: 'photos partagées en moyenne par mariage',
    why_stat2_label: "pour qu'un invité partage sa première photo",
    why_stat3_label: 'événements mémorisés depuis le lancement',
    why_stat4_label: 'note moyenne sur 127 avis vérifiés',
    why_cta: '→ Créer mon album  49,99€',
    why_cta_sub1: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg> Accès immédiat',
    why_cta_sub2: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><path d="M23 4v6h-6"></path><path d="M1 20v-6h6"></path><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path></svg> Remboursé sous 30 jours',
    why_cta_sub3: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Album actif 6 mois',
    why_demo_q: 'Vous voulez voir comment ça fonctionne avant d\'acheter ?',
    why_demo_btn: 'Tester la démo gratuite',
    sticky_name: 'QR Code Mariage et Anniversaire, Album Photo & Vidéo Invités',
    sticky_btn: '→ Créer mon album',

    vid_tag: 'En images',
    vid_title: 'Créez votre album<br>en <em>moins de 5 minutes</em>',
    vid_sub: 'Suivez ces 4 étapes simples. Chaque vidéo vous montre exactement quoi faire.',
    vid_step: 'Étape',
    vid_s1_title: 'Connectez-vous',
    vid_s1_desc: 'Accédez à votre espace KeepMemoriz et téléchargez votre carte de table personnalisée avec QR code',
    vid_s2_title: 'Configurer votre album',
    vid_s2_desc: 'Décidez qui peut ajouter, voir ou télécharger les photos et vidéos.',
    vid_s3_title: 'Imprimez et carte de tablez le QR code',
    vid_s3_desc: "Carte de tablez le QR code sur vos tables, votre plan de salle ou à l'entrée de la réception.",
    vid_s4_title: 'Télécharger vos souvenirs',
    vid_s4_desc: "Après l'événement, téléchargez toutes vos photos & vidéos en un seul clic et revivez votre évènement à travers le regard de vos proches.",
    vid_demo_text: 'Vous venez de voir comment ça fonctionne : créez votre album maintenant.',
    vid_demo_btn: 'Créer mon album, 49,99€',
    vid_demo_note: 'Sans carte bancaire · Sans inscription · Accès en 30 secondes',
    vid_placeholder: 'Vidéo étape',

    reviews_count: '127 avis vérifiés',
    reviews_title: 'Ils nous font<br><em>confiance</em>',
    reviews_sub: 'Des centaines de familles ont immortalisé leurs moments.',
    reviews_track1: null,
    reviews_track2: null
  };

  // Expose globally
  window.KM_T = T;
})();